<template>
  <div class="doc-content">
    <h4>接口文档</h4>
    <div class="markdown-body" data-color-mode="light" data-light-theme="light">
      <vue-markdown :source="markdownContent" />
    </div>
    <a-back-top :target="targetFn">
      <div class="ant-back-top-inner">
        <a-icon type="caret-up" />
      </div>
    </a-back-top>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
import markdownContent from '@/assets/格如灵实验开放平台文档-标准版.md' // 直接导入 Markdown 文件内容
import 'github-markdown-css'
import { BackTop } from 'ant-design-vue'

export default {
  name: 'Document',
  components: {
    VueMarkdown,
    'a-back-top': BackTop
  },
  data() {
    return {
      markdownContent: markdownContent
    }
  },
  mounted() {},
  methods: {
    targetFn() {
      return document.querySelector('.doc-content')
    }
  }
}
</script>

<style lang="less" scoped>
.doc-content {
  padding: 20px 27px 20px !important;
  .markdown-body {
    box-sizing: border-box;
    min-width: 200px;
    margin: 0 auto;
    padding: 0 20px 20px;
  }
  h4 {
    font-size: 16px;
    font-weight: 800;
    color: #000000;
    line-height: 22px;
  }
  /deep/ .ant-back-top {
    bottom: 100px;
  }
  /deep/ .ant-back-top-inner {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    line-height: 36px;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    text-align: center;
    font-size: 17px;
  }
  /deep/ .ant-back-top {
    right: 60px !important;
  }
}
</style>
